import { useEffect, useState } from 'react'

/** Advances one item per tick; parks on the last item, or starts another pass when looping. */
export function useScan(count: number, ms: number, running: boolean, loop = false) {
  const [index, setIndex] = useState(0)
  useEffect(() => {
    if (!running || count < 2) return
    const timer = window.setInterval(
      () => setIndex((value) => (loop ? (value + 1) % count : Math.min(value + 1, count - 1))),
      ms,
    )
    return () => window.clearInterval(timer)
  }, [count, ms, running, loop])
  return Math.min(index, Math.max(0, count - 1))
}

/** Class for content the AI just produced: it settles into place out of a light blur. */
export const aiEnter = 'animate-[qb-ai-enter_460ms_cubic-bezier(0.16,1,0.3,1)_both]'

/**
 * Keys that appeared since the previous render. The first render and same-size swaps (a saved line
 * replacing its optimistic copy) report nothing, so only real additions animate.
 */
export function useArrivals<K extends string | number>(keys: K[]) {
  const [state, setState] = useState(() => ({ seen: keys, arrived: new Set<K>() }))
  const changed = keys.length !== state.seen.length || keys.some((key, index) => key !== state.seen[index])
  if (changed) {
    const arrived = new Set(state.arrived)
    if (keys.length > state.seen.length) {
      const previous = new Set(state.seen)
      for (const key of keys) if (!previous.has(key)) arrived.add(key)
    }
    setState({ seen: keys, arrived })
    return arrived
  }
  return state.arrived
}
